import { render, staticRenderFns } from "./image-basic.vue?vue&type=template&id=72f02632"
import script from "./image-basic.vue?vue&type=script&setup=true&lang=js"
export * from "./image-basic.vue?vue&type=script&setup=true&lang=js"
import style0 from "./image-basic.vue?vue&type=style&index=0&id=72f02632&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports